import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../figma/colors-v2';
import { withDeserializeHTML } from '../../../../figma/DolEditor/deserializers/html-deserializer/withDeserializeHTML';
import { DolEditor } from '../../../../figma/DolEditor/DolEditor';
import { normalizeListItemOnPaste } from '../../../../figma/DolEditor/marks/list/normalizeListItemOnPaste';
import { deviceBreakpoints } from '../../../../hooks/useDeviceQuery.hook';
import { SoftBreakPlugin } from '../../../../slatePlugins/handlers/soft-break/SoftBreakPlugin';
import { BoldPlugin } from '../../../../slatePlugins/marks/bold/BoldPlugin';
import { DEFAULTS_BOLD } from '../../../../slatePlugins/marks/bold/defaults';
import { withInlineVoid } from '../../../../slatePlugins/plugins/inline-void/withInlineVoid';
import { ViewVocabIdeaEditorProps } from '../shared/ViewVocabIdeaEditor';
import {
  OutlineParagraphPlugin,
  withSingleOutlineParagraphNode,
} from './Paragraph/OutlineParagraphPlugin';

const Main = styled.div`
  padding: 24px;
  background-color: ${colorsV2.white100};
  border-radius: 16px;

  .dol-editor {
    font-family: noto-serif, serif;
    font-size: 16px;
    line-height: 24px;
    .h3 {
      font-size: 18px;
      line-height: 28.8px;

      margin-bottom: 0;
      font-weight: 700;
    }
  }

  &.read-only {
    background-color: transparent;
    padding: 0;

    .outline-paragraph-title-element {
      color: ${colorsV2.primary100};
    }
  }

  @media ${deviceBreakpoints.fromTablet} {
    .dol-editor {
      font-size: 20px;
      line-height: 32px;
      .h3 {
        font-size: 20px;
        line-height: 32px;
        font-weight: 600;
      }
    }
  }
`;

export const OutlineParagraphEditor = (props: ViewVocabIdeaEditorProps) => {
  const { title, isReadOnly, ...rest } = props;
  const plugins = React.useMemo(
    () => [
      SoftBreakPlugin({
        rules: [
          {
            hotkey: 'shift+enter',
          },
        ],
      }),
      BoldPlugin(DEFAULTS_BOLD),
      OutlineParagraphPlugin({ isReadOnly }),
    ],
    [isReadOnly]
  );

  const editorChains = React.useMemo(
    () => [
      withInlineVoid({ plugins }),
      withDeserializeHTML({ plugins: plugins as any, normalizeFragment: normalizeListItemOnPaste }), // This must be above any plugins handle copy/paste ( so it won't add default html handling )
      withSingleOutlineParagraphNode(),
    ],
    [plugins]
  );

  return (
    <Main className={cl('outline-paragraph', { 'read-only': isReadOnly })}>
      <DolEditor plugins={plugins} editorChains={editorChains} readOnly={isReadOnly} {...rest} />
    </Main>
  );
};
